import {AUTH_TOKEN, API_URL} from "./constants/api";
import axios from 'axios';

// axios.defaults.headers['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers['Accept-Language'] = 'En';
// axios.defaults.baseURL = API_URL;

const METHODS = {

    isPatientVerify: function () {
        return this.get('/isPatientVerify').then((result) => {
            return {
                ...result.data,
                validateLogin:  !!(result.data.status == "success" && result.data.patient_verified == true && result.data.patient_id)
            }
        });
    },
    getGeneralClinicInfo: function () {
        return this.get('getClinicInfo').then((result) => result.data);
    },
    cancelApp: function (data) {
        return this.post('/cancelAppointment', data);
    }

};

const API = {
    ...axios.create({
        baseURL: API_URL
    }), ...METHODS
};


export default API;
